import { render, staticRenderFns } from "./portfolio-carousel.vue?vue&type=template&id=335e5198&scoped=true"
import script from "./portfolio-carousel.vue?vue&type=script&lang=js"
export * from "./portfolio-carousel.vue?vue&type=script&lang=js"
import style0 from "./portfolio-carousel.vue?vue&type=style&index=0&id=335e5198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335e5198",
  null
  
)

export default component.exports